<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="msg-modal u-window" :class="{'small' : giftList.length  == 1 , 'mid' : giftList.length && giftList.length < 5}">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <h5 class="dialog-title" v-if="fromType == 1">购买成功</h5>

                    <h5 class="title" v-if="have_free()">恭喜您获得了<b>双11狂欢赠礼</b>，这是您购买的道具：</h5>
                    <h5 class="title" v-else>道具已发放至军师邮件，请注意查收！</h5>

                    <div class="reward-view" v-if="giftList.length">
                        <div class="reward-item" v-for="(item,index) in giftList" :key="index">
                            <div class="r-wrapper" v-tips="item.giftId">
                                <div class="pic">
                                    <game-item :locked="true" :id="item.giftId" :num="item.sendNum || item.num || 1"></game-item>
                                    <div class="icon-free" v-if="item.flag"></div>
                                </div>                                
                            </div>                              
                        </div>

                        <div class="reward-item">
                            <div class="r-wrapper">
                                <div class="pic">
                                    <div class="item-score">
                                        <div class="num">{{ cost }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="notice" v-if="have_free()">道具已发放至军师邮件，请注意查收！</div>

                    <div class="u-btn ok" @click="closeModal"></div>

                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>

    .dialog-title{
        margin-bottom: 10px;
    }

    .title{
        text-align: center;
        font-size: 22px;
        font-weight: 400;
        color: #666565;

        b{
            color: #ea583f;
        }
    }

    .reward-view{
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        padding: 18px 20px;
        margin: 20px 0 0;
        background-color: #fffaed;
    }

    .small .reward-view,
    .mid .reward-view{
        // margin-top: 90px;
    }

    .reward-item{
        position: relative;
        margin: 0 10px 18px;
        box-sizing: border-box;

        transform: scale(0);
        opacity: 0;
        transform-origin: center;
        animation: box_show 0.4s;
        animation-fill-mode: forwards;

        @for $i from 1 through 10{
            &:nth-child(#{$i}) {                
                animation-delay: $i*0.5s;               
            }
        }      
    }

    .r-wrapper{
        position: relative;
        width: 68px;
        height: 68px;
        margin: 0 auto;
    }

    .r-wrapper>.pic{
        position: relative;
        width: 100%;
        height: 100%;
    }

    .icon-free{
        position: absolute;
        right: 0;
        top: 0;
        width: 21px;
        height: 21px;
        background-image: url(~@/assets/images/modal/icon-free.png);    
    }

    .item-score{
        width: 68px;
        height: 68px;
        background-image: url(~@/assets/images/score.png);
        
        .num{
            position: absolute;
            right: 0;
            bottom: 0;
            // width: 20px;
            height: 26px;
            line-height: 26px;
            text-align: center;
            background-color: #ea583f;
            font-size: 16px;
            color: #fdf9ed;
            border-radius: 5px;
        }
    }


    .notice{
        text-align: center;
        font-size: 22px;
        color: #ada9a9;
    }

    .u-btn.ok{
        width: 190px;
        height: 54px;
        margin: 20px auto 0;
        background-image: url(~@/assets/images/modal/btn-ok.png);  
    }

</style>

<script>

export default {
    data () {
        return {
            visible : false,
            text : '',
            rid : 1,
            giftList : [],
            gacha_index : 1,
            rest : 10,
            cost : 0,
            fromType : 0,  //1购买成功 01111包
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
    },
    methods : {
        destroyElement () {
            document.body.style.overflow = ''; // 出现滚动条
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },        
        closeModal(){
            this.destroyElement()
        },
        have_free(){
            for(let i=0; i<this.giftList.length; i++){
                if(this.giftList[i].flag){
                    return true;
                }
            }
            return false;
        }            
    },    
}
</script>